import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, params, callback) => {
    return AppModel.post('customer', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      let modelStore = store.getters.model
      if (!modelStore) {
        modelStore = {}
      }
      modelStore['customerRegist'] = res.data
      store.commit('setModel', modelStore)

      return Promise.resolve(res.data)
    }, null, callback)
  },
  getStore: (key) => {
    return AppModel.getStore('customerRegist', 'customerRegist', key)
  },
  removeStore: () => {
    delete store.getters.model.customerRegist
  }
}
